import { Button, ButtonAdd, Checkbox, Divider, Popover } from '@seiue/ui'
import { omit } from '@seiue/util'
import { useState } from 'react'
import styled from 'styled-components'

import { InputSearch } from 'packages/components/InputSearch'
import { PluginStatusEnum } from 'packages/sdks-next/growp'
import { getTheme } from 'packages/theme'
import { AnyType } from 'packages/types'

import { TagDrawer } from './TagDrawer'
import { ButtonAddContent } from './components/ButtonAddContent'

/**
 * 门户管理 应用列表-头部
 *
 * @param param - 参数
 * @param param.title - 标题
 * @param param.query - 筛选参数
 * @param param.setQuery - 设置筛选参数
 * @param param.hiddenOpenCheck - 是否隐藏只看已开启
 * @param param.hiddenRightButton - 是否隐藏右侧按钮
 * @returns 组件
 */
export const Header: React.FC<{
  hiddenOpenCheck?: boolean
  hiddenRightButton?: boolean
  title: string
  query: AnyType
  setQuery: (query: AnyType) => void
}> = ({ hiddenOpenCheck, hiddenRightButton, title, query, setQuery }) => {
  const theme = getTheme()
  const [visible, setVisible] = useState<boolean>(false)

  return (
    <HeaderBox>
      <Title>{title}</Title>
      <ButtonBox>
        {hiddenOpenCheck ? null : (
          <>
            <Checkbox
              style={{ marginRight: '-12px', color: theme.text._2 }}
              onChange={(e) => {
                setQuery({
                  ...query,
                  statusIn: e.target.checked
                    ? PluginStatusEnum.Enabled
                    : undefined,
                })
              }}
            >
              {'仅显示启用'}
            </Checkbox>
            <Divider vertical={true} />
          </>
        )}

        <InputSearch
          placeholder="搜索应用名称"
          onPressEnter={(e) => {
            const v = (e.target as HTMLInputElement).value
            v
              ? setQuery({ ...query, labelLike: v })
              : setQuery(omit(query, ['labelLike']))
          }}
          allowClear={true}
          onClear={() => setQuery(omit(query, ['labelLike']))}
        />
        {hiddenRightButton ? null : (
          <>
            <Button
              icon="Backstage"
              style={{ marginRight: 0 }}
              onClick={() => setVisible(true)}
            >
              {'分类管理'}
            </Button>
            <StyledPopover
              placement="bottomRight"
              content={<ButtonAddContent />}
            >
              <ButtonAdd
                type="primary"
                style={{ fontWeight: 'normal', marginRight: 0 }}
              >
                {'添加应用'}
              </ButtonAdd>
            </StyledPopover>
          </>
        )}
      </ButtonBox>

      {visible ? (
        <TagDrawer
          visible={visible}
          setVisible={setVisible}
        />
      ) : null}
    </HeaderBox>
  )
}

const HeaderBox = styled.div`
  display: flex;
  height: 52px;
  padding: 20px 20px 0px 20px;
  justify-content: space-between;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  height: 26px;
  color: ${(props) => props.theme.text._1};
`
const ButtonBox = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

const StyledPopover = styled(Popover)`
  & .ant-popover-inner {
    border-radius: 12px;
  }
`
